import { render, staticRenderFns } from "./auth-claim-detail.vue?vue&type=template&id=0e2215b5&scoped=true&"
import script from "./auth-claim-detail.vue?vue&type=script&lang=js&"
export * from "./auth-claim-detail.vue?vue&type=script&lang=js&"
import style0 from "./auth-claim-detail.vue?vue&type=style&index=0&id=0e2215b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2215b5",
  null
  
)

export default component.exports